module.exports = __webpack_public_path__ + "img/logo.914127ac.svg";